import { css } from 'emotion';

import { colors, icons } from '@cobliteam/base-components/src/styles';

const blockButton = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 20px);
  max-width: 70px;
  padding: 20px;
  border-left: 1px solid ${colors.gray.light};
`;

const blockIcon = css`
  color: ${colors.gray.dark};
  background: ${colors.gray.lightest};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${colors.gray.default};
  border-radius: 5px;
  width: 30px;
  height: 30px;

  > svg {
    width: ${icons.size.small};
    height: ${icons.size.small};
  }
`;

export default {
  blockButton,
  blockIcon,
};
